// extracted by mini-css-extract-plugin
module.exports = {"content":"ConsumerDetails_content__HoXh0","factorsList":"ConsumerDetails_factorsList__SYo0R","suggestion":"ConsumerDetails_suggestion__6CJHe"};